import objectFitImages from 'object-fit-images';

/**
 * Sets up polyfill for css objectfit
 * 
 * See (https://github.com/fregante/object-fit-images)
 */

export class ObjectFitModule {

    constructor() {
        objectFitImages();
    }
}



// WEBPACK FOOTER //
// ./assets/scripts/front/App/ObjectFitModule.js